module.exports = __webpack_public_path__ + "cr.46b19aa9.svg";